import React, { useState, useEffect } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import TableauDynamique from "../../composant_reutilisable/tableau";
import { BsPeople } from "react-icons/bs";
import { Modal, Button } from "react-bootstrap"; // Ajout du modal Bootstrap
import ModalComponent from "../../composant_reutilisable/composant_modal";
import { FaArrowLeft, FaArrowRight, FaCalendarAlt, FaCogs, FaEllipsisV, FaPlus, FaQuestionCircle, FaSortAmountDown, FaSortAmountUp, FaTrash, FaUser, FaUserPlus, FaUsers } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Footer from "../../composant_reutilisable/footer";
import CollaborationModal from "./collaboration";
import InvitesModal from "./invites";
import axios from "axios";


const ListeEvenement = () => {
    useAuth();
    const navigate = useNavigate();

    // const utilisateur_id = localStorage.getItem("utilisateur_id");
    const [isLoading, setIsLoading] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [sortConfig, setSortConfig] = useState({
        key: "id",
        direction: "descending",
    });

    const [groupes, setGroupes] = useState([]);
    const [evenements, setEvenements] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [groupeSelectionne, setGroupeSelectionne] = useState(null);
    const [evenementSelectionne, setEvenementSelectionne] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showCollaborationModal, setShowCollaborationModal] = useState(false);
    const [showInvitesModal, setShowInvitesModal] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "Showtime | Liste Evènement";
        }
    }, [user_id]);

    // États pour gérer le modal
    const [showModal, setShowModal] = useState(false);
    const [nouveauGroupe, setNouveauGroupe] = useState({ titre: "", description: "" });

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 2000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 5000);
    };

    // Récupération des évènements
    const fetchEvenements = async () => {
        try {
            setIsLoading(true);
            const token = localStorage.getItem('access_token')
            const response = await fetch(process.env.REACT_APP_HOTE + "/api/listes-evenements-admin/", {
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`
                },
            });
            if (response.ok) {
                const data = await response.json();

                const formatted = data.data.map(ev => ({
                    ...ev,

                    // // ✅ transformation contrôlée
                    // est_gratuit_label: ev.est_gratuit
                    //     ? <span className="badge badge-success">Oui</span>
                    //     : <span className="badge badge-danger">Non</span>,

                    // // est_gratuit_label: ev.est_gratuit ? "Oui" : "Non",
                    // sur_invitation_label: ev.sur_invitation ? "Oui" : "Non",

                    // // tickets = nombre affichable
                    // tickets_count: ev.tickets?.length || 0,
                }));

                setEvenements(formatted);
            }
        } catch (error) {
            console.error("Erreur récupération événements :", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchEvenements();
    }, []);

    const colonnesEvenements = [
        // { titre: "Référence", cle: "ref_evenement" },
        { titre: "Titre", cle: "titre" },
        { titre: "Description", cle: "description" },
        { titre: "Lieu", cle: "nom_lieu" },
        { titre: "Catégorie", cle: "categorie" },
        { titre: "Statut", cle: "statut_evenement" },
        { titre: "Date début événement", cle: "date_debut_evenement" },
        { titre: "Date fin événement", cle: "date_fin_evenement" },
        { titre: "Créer le", cle: "date_creation" },
        // { titre: "Compte organisateur", cle: "organisateur_ref_compte" },
        { titre: "Organisateurs", cle: "organisateur_pseudo" },

    ];

    // const evenementsData = [
    //     {
    //         id: 1,
    //         titre: "Conférence Tech 2025",
    //         description: "Une conférence sur les dernières innovations technologiques.",
    //         visibilite: "publique",
    //         date: "2025-07-15",
    //         produits: "Badge, T-shirt",
    //         gratuit: false,
    //         sur_invitation: true,
    //         categorie: "Technologie",
    //         created_at: "2025-06-01",
    //         tickets: 150,
    //         // lieu: "Palais des Congrès - Paris",
    //         ajoute_par: "John Doe",
    //         // statut: "à venir",
    //         // participants: 120
    //     },
    //     {
    //         id: 2,
    //         titre: "Soirée Jazz Privée",
    //         description: "Un événement exclusif pour les amateurs de jazz.",
    //         visibilite: "privée",
    //         date: "2025-08-20",
    //         produits: "Cocktail, Brochure",
    //         gratuit: true,
    //         sur_invitation: true,
    //         categorie: "Musique",
    //         created_at: "2025-06-10",
    //         tickets: 50,
    //         // lieu: "Le Jazz Club - Lyon",
    //         ajoute_par: "Alice Smith",
    //         // statut: "à venir",
    //         // participants: 48
    //     },
    //     {
    //         id: 3,
    //         titre: "Salon de l’emploi",
    //         description: "Rencontre entre entreprises et chercheurs d'emploi.",
    //         visibilite: "publique",
    //         date: "2025-09-05",
    //         produits: "Dossier candidat, Goodies",
    //         gratuit: true,
    //         sur_invitation: false,
    //         categorie: "Carrière",
    //         created_at: "2025-05-28",
    //         tickets: 300,
    //         // lieu: "Centre Expo - Marseille",
    //         ajoute_par: "Pôle Emploi",
    //         // statut: "à venir",
    //         // participants: 280
    //     },
    //     {
    //         id: 4,
    //         titre: "Webinar - Design UI/UX",
    //         description: "Un atelier en ligne pour améliorer ses compétences en design.",
    //         visibilite: "publique",
    //         date: "2025-06-25",
    //         produits: "PDF, Certificat",
    //         gratuit: true,
    //         sur_invitation: false,
    //         categorie: "Formation",
    //         created_at: "2025-06-01",
    //         tickets: 100,
    //         // lieu: "En ligne",
    //         ajoute_par: "DesignSchool",
    //         // statut: "à venir",
    //         // participants: 95
    //     },
    //     {
    //         id: 5,
    //         titre: "Festival des Saveurs",
    //         description: "Un voyage culinaire autour du monde.",
    //         visibilite: "publique",
    //         date: "2025-07-10",
    //         produits: "Dégustation, Sac",
    //         gratuit: false,
    //         sur_invitation: false,
    //         categorie: "Gastronomie",
    //         created_at: "2025-06-02",
    //         tickets: 500,
    //         // lieu: "Parc de la Villette",
    //         ajoute_par: "Saveurs du Monde",
    //         // statut: "à venir",
    //         // participants: 470
    //     }
    // ];

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };


    // Filtrage

    const evenementsFiltres = evenements.filter(evenement =>
        evenement?.nom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.visibilite?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.date?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.produits?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.est_gratuit_label?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.sur_invitation_label?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.categorie?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.created_at?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        evenement?.tickets_count?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Tri des données
    const evenementsTries = [...evenementsFiltres].sort((a, b) => {
        if (sortConfig.key) {
            const valueA = a[sortConfig.key]?.toString().toLowerCase() || "";
            const valueB = b[sortConfig.key]?.toString().toLowerCase() || "";
            if (valueA < valueB) return sortConfig.direction === "ascending" ? -1 : 1;
            if (valueA > valueB) return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
    });

    // Pagination
    const totalItems = evenementsFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const evenementsAffiches = evenementsTries.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelectionGroupe = (evenement) => {
        setGroupeSelectionne(evenement);
    };

    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    // Gestion du formulaire d'ajout
    const handleChange = (e) => {
        setNouveauGroupe({ ...nouveauGroupe, [e.target.name]: e.target.value });
    };


    const handleShowDeleteModal = (groupeSelectionne) => {
        setGroupeSelectionne(groupeSelectionne);
        if (!groupeSelectionne) return;
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const colonnesdropdown = [
        {
            label: "Configurer",
            icon: <FaCogs color="blue" />,
            actionKey: "configurer",
        },
        {
            label: "Supprimer",
            icon: <FaTrash color="red" />,
            actionKey: "delete",
        },
        {
            label: "Collaboration",
            icon: <FaUsers color="green" />,
            actionKey: "collaboration",
        },
        {
            label: "Invitations",
            icon: <FaUserPlus color="green" />,
            actionKey: "invites",
        }
    ];

    const handleAction = (evenementSelected, action) => {
        console.log("groupe sélectionné :", evenementSelected);
        console.log("Action reçue :", action);
        if (!evenementSelected || !action) {
            console.error("Action invalide ou utilisateur non défini");
            return;
        }

        switch (action.actionKey) {
            case "configurer":
                handleConfigurer(evenementSelected);
                break;
            case "delete":
                handleShowDeleteModal(evenementSelected);
                break;
            case "collaboration":
                handleCollaboration(evenementSelected);
                break;
            case "invites":
                handleInvitation(evenementSelected);
                break;
            default:
                console.log("Action inconnue :", action);
        }
    };


    const handleDeleteGroupe = async () => {
        if (evenementSelectionne) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-groupe/${evenementSelectionne.id}/${user_id}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setEvenements(evenements.filter((evenement) => evenement.id !== evenementSelectionne.id));
                    setEvenementSelectionne(null);

                    // Stocker le message de succès dans localStorage
                    showAlert('Evenement supprimé avec succès !');
                } else {
                    console.error('Erreur lors de la suppression du Evenement');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleConfigurer = (evenement) => {
        if (evenement) {
            navigate(`/Configurer-evenement`, {
                state: { evenement_id: evenement.id }, // Passage de l'ID par l'état
            });
        }
    };

    const handleCollaboration = (evenement) => {
        setEvenementSelectionne(evenement);
        setShowCollaborationModal(true);
    };

    const handleInvitation = (evenement) => {
        setEvenementSelectionne(evenement);
        setShowInvitesModal(true);
    };

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    // if (!accesGroupes.includes("Groupes")) {
    //     return (
    //         <Pas_acces />
    //     );
    // }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaCalendarAlt size={25} className='mr-2' />Gestion des évènements
                                </div>
                            </h2>
                            <small>Administration des évènements.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={`/Dashboard`}>Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Evènement
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des évenements</h5>
                            <div className="text-right">
                                {/* <button className="btn btn-success mr-2" onClick={handleOpenModal}>
                                    <FaPlus />Ajouter
                                </button> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">

                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="me-2">
                                                <select
                                                    value={itemsPerPage}
                                                    onChange={handleItemsPerPageChange}
                                                    className="form-select bg-default p-1"
                                                    style={{
                                                        width: "auto",
                                                        border: "1px black solid",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                            </div>
                                            <div className="row justify-content-center align-items-center">
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control mr-2"
                                                    style={{ maxWidth: "150px", width: "100%" }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="table-responsive">
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                <thead>
                                                    <tr>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort("titre")}>
                                                            Titre
                                                            {sortConfig.key === "titre"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        {/* <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort("description")}>
                                                            Description
                                                            {sortConfig.key === "description"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th> */}
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("nom_lieu")}>
                                                            Lieu
                                                            {sortConfig.key === "nom_lieu"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("categorie")}>
                                                            Catégorie
                                                            {sortConfig.key === "categorie"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("statut_evenement")}>
                                                            Statut
                                                            {sortConfig.key === "statut_evenement"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("date_debut_evenement")}>
                                                            Date début
                                                            {sortConfig.key === "date_debut_evenement"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("date_fin_evenement")}>
                                                            Date fin
                                                            {sortConfig.key === "date_fin_evenement"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("date_creation")}>
                                                            Créer le
                                                            {sortConfig.key === "date_creation"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("organisateur_pseudo")}>
                                                            Organisateur
                                                            {sortConfig.key === "organisateur_pseudo"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-center">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">Chargement...</td>
                                                        </tr>
                                                    ) : evenementsAffiches.length > 0 ? (
                                                        evenementsAffiches.map((evenement) => (
                                                            <tr key={evenement.id}>
                                                                <td className="d-none d-md-table-cell">{evenement.titre}</td>
                                                                {/* <td className="d-none d-md-table-cell text-center">{evenement.description}</td> */}
                                                                <td className="d-none d-md-table-cell text-center">{evenement.nom_lieu}</td>
                                                                <td className="d-none d-md-table-cell text-center">{evenement.categorie}</td>
                                                                <td className="d-none d-md-table-cell text-center">{evenement.statut_evenement}</td>
                                                                <td className="d-none d-md-table-cell text-center">{evenement.date_debut_evenement}</td>
                                                                <td className="d-none d-md-table-cell text-center">{evenement.date_fin_evenement}</td>
                                                                <td className="d-none d-md-table-cell text-center">{evenement.date_creation}</td>
                                                                <td className="d-none d-md-table-cell text-center">{evenement.organisateur_pseudo}</td>
                                                                <td className="text-center" style={{ position: 'relative' }}>
                                                                    <div>
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setOpenDropdownId(openDropdownId === evenement.id ? null : evenement.id);
                                                                            }}
                                                                            style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                padding: '0 5px',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        >
                                                                            <FaEllipsisV title="Actions" />
                                                                        </button>

                                                                        {openDropdownId === evenement.id && (
                                                                            <div
                                                                                style={{
                                                                                    position: 'fixed',
                                                                                    zIndex: 1000,
                                                                                    minWidth: '150px',
                                                                                    right: '50px',
                                                                                    backgroundColor: 'white',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '4px',
                                                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                                                    maxHeight: '150px',
                                                                                    overflowY: 'auto',
                                                                                    scrollbarWidth: 'thin',
                                                                                    scrollbarColor: '#ddd #f8f9fa',
                                                                                }}
                                                                                className="custom-scrollbar"
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleConfigurer(evenement);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaCogs className="mr-2" style={{ color: "blue" }} size={14} />
                                                                                    <span>Configurer</span>
                                                                                </div>

                                                                                <div style={{ borderTop: '1px solid #eee' }} />

                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleCollaboration(evenement);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaUsers className="mr-2" style={{ color: "green" }} size={14} />
                                                                                    <span>Collaborations</span>
                                                                                </div>

                                                                                <div style={{ borderTop: '1px solid #eee' }} />

                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleInvitation(evenement);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaUserPlus className="mr-2" style={{ color: "greenyellow" }} size={14} />
                                                                                    <span>Invitations</span>
                                                                                </div>

                                                                                {/* <div style={{ borderTop: '1px solid #eee' }} />

                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowDeleteModal(evenement);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaTrash className="mr-2" style={{ color: "red" }} size={14} />
                                                                                    <span>Supprimer</span>
                                                                                </div> */}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">Aucun évenement trouvé.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div>
                                                {evenementsFiltres.length === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Affichage de ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, evenementsFiltres.length)} sur ${evenementsFiltres.length}`}
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                    className={`btn ${currentPage === 1 ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === 1}
                                                >
                                                    <FaArrowLeft />
                                                </button>

                                                {(() => {
                                                    const pagesToShow = 5;
                                                    let startPage = Math.max(
                                                        1,
                                                        currentPage - Math.floor(pagesToShow / 2)
                                                    );
                                                    let endPage = Math.min(
                                                        totalPages,
                                                        startPage + pagesToShow - 1
                                                    );

                                                    if (endPage - startPage < pagesToShow - 1) {
                                                        startPage = Math.max(
                                                            1,
                                                            endPage - pagesToShow + 1
                                                        );
                                                    }

                                                    const pageButtons = [];

                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageButtons.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => setCurrentPage(i)}
                                                                className={`btn ${currentPage === i
                                                                    ? "btn-default"
                                                                    : "btn-light"
                                                                    } mx-1`}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }

                                                    return pageButtons;
                                                })()}
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                    className={`btn ${currentPage === totalPages ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <FaArrowRight />
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Footer />

                </div>
            </div>



            {/* <ModalComponent
                show={showModal}
                handleClose={handleCloseModal}
                title="Créer un groupe"
                fields={[
                    { name: "titre", label: "Titre", placeholder: "Titre du groupe", required: true },
                    { name: "description", label: "Description", type: "textarea", placeholder: "Description du groupe", required: true },
                    // { 
                    //     name: "type_groupe", 
                    //     label: "Type du groupe", 
                    //     type: "select", 
                    //     options: [
                    //         { value: "admin", label: "Groupe système" },
                    //         { value: "user", label: "Utilisateur" },
                    //     ], 
                    //     required: true 
                    // }
                ]}
                formData={nouveauGroupe}
                handleChange={handleChange}
                handleSubmit={handleAjouterGroupe}
                submitText="Ajouter"
            /> */}

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer la suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer le groupe <strong>{groupeSelectionne?.titre}</strong> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        <strong>Annuler</strong>

                    </Button>
                    <Button variant="success" onClick={handleDeleteGroupe}>
                        <strong>Supprimer</strong>

                    </Button>
                </Modal.Footer>
            </Modal>

            <CollaborationModal
                show={showCollaborationModal}
                onHide={() => setShowCollaborationModal(false)}
                evenementId={evenementSelectionne?.id}
            // token={token}
            />

            <InvitesModal
                show={showInvitesModal}
                onHide={() => setShowInvitesModal(false)}
                evenementId={evenementSelectionne?.id}
            // token={token}
            />


        </div>
    );
};

export default ListeEvenement;
